(function () {
    
'use strict';


angular
    .module('com.module.projects')
    .component('projectAssessments', {
        templateUrl: 'app/modules/projects/components/project-assessments/template.html',
        bindings: {
            'project': '='
        },
        controllerAs: 'vm',
        controller: projectAssessments
    });
        
        
        /* ngInject */
        function projectAssessments($scope,$uibModal, AssessmentService, GridHelper,CoreService,$state) {
            var vm = this;

            // init config
            AssessmentService.setProject(vm.project);
            vm.config={
                controllerAs:'vm'
            };
            
            /* List */
            var schema = AssessmentService.gridSchema;
            vm.pagination = {
                pageNumber: 1,
                pageSize: 25,
                sort: null
            };
            vm.filters = {};
            vm.loadListData = function(filters) {
                
                filters = filters || vm.filters;
                console.log("Req Filter", filters);
                
                // when you search make sure you dont skip records
                if (filters.where && Object.keys(filters.where).length > 0) {
                    vm.pagination.pageNumber = 1;
                    filters.skip = 0;
                }
              
                vm.promise = AssessmentService.get(filters).then(function(res) {
                    var headers = res.headers();
                    vm.gridOptions.totalItems = Number(headers['x-total-count']);
                    vm.gridOptions.data = res.data.sort(function(a,b){return a.order-b.order;}); //postProcess(res.data);
                });
            };
            
            
            vm.gridOptions = GridHelper.gridOptions(schema, vm.loadListData, vm.pagination, vm.filters,vm.config);
            vm.gridOptions.rowTemplate= '<div grid="grid" class="ui-grid-draggable-row" draggable="true"><div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader, \'custom\': true }" ui-grid-cell></div></div>'

            vm.loadListData();
            // ui-grid-draggable-rows
            vm.dragEnable = true;
            vm.gridOptions.onRegisterApi = function (gridApi) {
                
                gridApi.draggableRows.on.rowFinishDrag(null, function () {
                    vm.changeOrder(vm.gridOptions.data)
                });
                
            };
            
            /* reorder function */
            vm.changeOrder = function(assessments){
                var changed=false;
                var ids=[];
                for (var i = 0; i < assessments.length; i++) {
                    ids.push(assessments[i].id);
                    if(assessments[i].order!==i) {
                        assessments[i].order = i;
                        changed=true;
                    }
                }
                if(changed) AssessmentService.saveOrder(ids).then(CoreService.success).catch(CoreService.error);
                else CoreService.warning({},'Order not changed')
            }
            
            /* Single */
            
            vm.item = {};
            vm.formSchema = AssessmentService.getFormSchema();
            vm.closeForm = function(){
                vm.formOpen = false;            
                vm.loadListData();
            };
            vm.viewElement = CoreService.viewElement;
            vm.createElement = function(item){
                console.log("Create",item);
                vm.formOpen = !vm.formOpen;
                vm.item={};
            };
            vm.editElement = function(item){
                console.log("Edit",item);
                vm.formOpen = !vm.formOpen;
                vm.item=item;
                $state.go('app.projects.view.assessments.edit.proposals',{assessmentId:item.id});
            };
            vm.deleteElement = function(item){
                console.log("Delete",item);     
                CoreService.confirm('Are you sure?','Deleting this cannot be undone',
                  function () {
                    //   confirm
                    AssessmentService.delete(item).then(function () {
                        CoreService.success('Deleted successfully',(item.name||item.id)+' deleted!');
                        vm.loadListData();
                    }).catch(CoreService.error);
                  },
                  function () {
                    //   cancel
                  }
                );
            };
            vm.submit = function(){
                var item = vm.item;
                vm.promise = AssessmentService.save(item)
                    .then(function(res){
                        CoreService.success('Saved successfully',res.data.id);
                        vm.formOpen = !vm.formOpen;
                        vm.item=null;
                        return vm.loadListData();
                    }).catch(CoreService.error);
            };
            
            
        }
        
        
        
})();